import { useState, useContext, useEffect } from "react";

import SelectorButton from "../../../../Buttons/SelectorButton/SelectorButton";
import TextInputField from "../../../../DataInputFields/TextInputField/TextInputField";
import ContinueButton from "../../../../Buttons/SlideContinueButton/ContinueButton";

import ErrorContext from "../../../../../context/ErrorProvider";

import { getLoanPurposeOptionsByDomainName } from "../../../../../constants/loanPurpose";
import { DOMAIN_NAME } from "../../../../../constants";
import * as Errors from "../../../../../utils/errors";

import useDebounce from "../../../../../hooks/useDebounce";

export default function LoanPurpose({ addSelectorsData, loading }) {
  const LOAN_PURPOSE_OPTIONS = getLoanPurposeOptionsByDomainName(DOMAIN_NAME);

  const { error, setError, resetError } = useContext(ErrorContext);

  const initialState = {
    open: false,
    value: "",
  };
  const [otherInput, setOtherInput] = useState(initialState);
  const [loanPurpose, setLoanPurpose] = useState([]);

  const debouncedOtherLoanPurpose = useDebounce(otherInput.value, 400);
  useEffect(() => {
    if (debouncedOtherLoanPurpose) setLoanPurpose([debouncedOtherLoanPurpose]);
  }, [debouncedOtherLoanPurpose]);

  const handleLoanPurposeSelect = (purpose) => {
    if (purpose === "Other") {
      if (!otherInput.open) {
        setOtherInput((prev) => ({ ...prev, open: true }));
        setLoanPurpose([]);
      }
      // } else if (!loanPurpose.includes(purpose)) {
    } else {
      if (otherInput.open) {
        setOtherInput(initialState);
        if (error.error && error.type === Errors.PURPOSE_OF_LOAN) resetError();

        setLoanPurpose([purpose]);
      } else {
        if (loanPurpose.includes(purpose)) {
          const options = Array.from(loanPurpose);
          const eleIndex = options.indexOf(purpose);
          options.splice(eleIndex, 1);
          setLoanPurpose(options);
        } else {
          setLoanPurpose((prev) => [...prev, purpose]);
        }
      }
    }
  };

  const handleSubmit = (purposeOfLoan) => {
    addSelectorsData("purposeOfLoan", purposeOfLoan, Errors.PURPOSE_OF_LOAN, {
      slideName: "Marital Status",
      slideIndex: 6,
      slideIcon: "MaritalStatus",
    });
  };

  const handleOtherLoanPurpose = (purpose) => {
    if (!purpose) {
      setError({
        error: true,
        type: Errors.PURPOSE_OF_LOAN,
        message: Errors.NULL_PURPOSE_OF_LOAN,
      });

      return;
    }

    setOtherInput((prev) => ({ ...prev, value: purpose }));

    if (error.error && error.type === Errors.PURPOSE_OF_LOAN) resetError();
  };

  const handleSubmimtOtherLoanPurpose = () => {
    const loanPurposeCombined = loanPurpose.join(", ");
    handleSubmit(loanPurposeCombined);
  };
  return (
    <div className="carouselSlideWrapper">
      <div className="typographyContainer">
        <h1>Purpose of Loan</h1>
        <p>Please select purpose of Loan</p>
      </div>

      {LOAN_PURPOSE_OPTIONS.map(({ id, row }) => (
        <div
          key={id}
          className="genderInputContainer dataFieldsContainer selectInputContainer"
        >
          {row.map(({ id, label, icon }) => (
            <div key={id} className="maleGenderBtnBox">
              <SelectorButton
                label={label}
                handler={handleLoanPurposeSelect}
                icon={icon}
                selected={loanPurpose.includes(label)}
              />
            </div>
          ))}
        </div>
      ))}

      {otherInput.open ? (
        <div>
          <TextInputField
            type="text"
            label="Purpose of Loan"
            placeholder="Purpose of Loan"
            name="otherPurposeOfLoan"
            id="otherPurposeOfLoan"
            required={true}
            error={error}
            errorType={Errors.PURPOSE_OF_LOAN}
            handler={handleOtherLoanPurpose}
            onEnterHandler={handleSubmimtOtherLoanPurpose}
          />
        </div>
      ) : null}

      <div className="residentContinueBtn">
        <ContinueButton
          loading={loading}
          handler={handleSubmimtOtherLoanPurpose}
        />
      </div>
    </div>
  );
}
